import ApiService from "@/services/api.service";
import moment from 'moment';

const route = 'groups';

const groups = {
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getByAdministratorId(_administratorId) {
        return new Promise((resolve, reject) => {
            ApiService.get(route + "?administrator_id=" + _administratorId).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    add(_module) {
        _module.meeting_at = moment(_module.meeting_at).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        _module.meeting_at = moment(_module.meeting_at).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    }
};

export default groups;